import React from 'react';
import { ArrowRight, Sparkles, Zap, CreditCard } from 'lucide-react';

const HEADING = { fontFamily: "'Space Grotesk', system-ui, sans-serif" } as const;

export function FinalCTASection() {
  return (
    <section className="py-24 md:py-32 bg-[#0a0a1a] relative overflow-hidden">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-[3rem] bg-gradient-to-br from-[#141432] via-[#1e1e5a] to-[#141432] border border-[#4f46e5]/40 p-10 md:p-20 text-center overflow-hidden shadow-[0_40px_120px_-40px_rgba(79,70,229,0.5)]">
          <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[#4f46e5]/25 blur-[140px] rounded-full pointer-events-none" />
          <div
            className="absolute inset-0 opacity-[0.05] pointer-events-none"
            style={{
              backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
              backgroundSize: '32px 32px',
            }}
          />
          <div className="relative">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#0a0a1a]/60 text-[#a5b4fc] text-xs font-bold uppercase tracking-widest mb-8 border border-[#4f46e5]/30">
              <Sparkles className="h-3.5 w-3.5" />
              Prêt à démarrer ?
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-6 tracking-tighter" style={HEADING}>
              Accélérez vos projets{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4f46e5] to-[#a5b4fc]">
                dès aujourd'hui.
              </span>
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
              Rejoignez les équipes qui ont choisi Lapyno pour organiser leur travail et garder le contrôle.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
              <a
                href="https://app.lapyno.com/auth?mode=signup"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#4f46e5] hover:bg-[#4338ca] text-white rounded-2xl font-bold text-base transition-all shadow-[0_10px_40px_-10px_rgba(79,70,229,0.7)] hover:scale-[1.02]"
              >
                Essai gratuit 14 jours
                <ArrowRight className="h-4 w-4" />
              </a>
              <button
                type="button"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#0a0a1a]/40 border border-white/10 text-white rounded-2xl font-bold text-base hover:bg-[#0a0a1a]/60 transition-colors"
              >
                Demander une démo
              </button>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-slate-400">
              <div className="flex items-center gap-2"><Zap className="h-4 w-4 text-[#a5b4fc]" /><span>Setup en 2 minutes</span></div>
              <div className="flex items-center gap-2"><CreditCard className="h-4 w-4 text-[#a5b4fc]" /><span>Sans carte bancaire</span></div>
              <div className="flex items-center gap-2"><Sparkles className="h-4 w-4 text-[#a5b4fc]" /><span>Annulez à tout moment</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
